import { useRuntimeConfig } from "#app";

const regions = [
	{
		regionCode: "HU",
		name: "hungary",
		flag: "emojione:flag-for-hungary",
	},
	{
		regionCode: "RO",
		name: "romania",
		flag: "emojione:flag-for-romania",
	},
];

export default {
	/**
	 * @description The base URL for API requests. This is set to the API URL from the runtime config.
	 * @type {string}
	 */
	get API() {
		return useRuntimeConfig().public.activeConfig.apiUrl;
	},
	/**
	 * @description The base URL for the dashboard. This is set to the dashboard URL from the runtime config.
	 * @type {string}
	 */
	get dashUrl() {
		return useRuntimeConfig().public.activeConfig.dashUrl;
	},
	/**
	 * @description Current site is blue?
	 * @type {bool}
	 */
	get isBlue() {
		return useRuntimeConfig().public.activeConfig.isBlue;
	},
	/**
	 * @description Current site is not blue?
	 * @type {bool}
	 */
	get isNotBlueHU() {
		return useRuntimeConfig().public.activeConfig.isNotBlueHU;
	},
	/**
	 * @description Get the current domain name. Configuration option is in the .env file.
	 * @type {bool}
	 */
	get host() {
		return useRuntimeConfig().public.activeConfig.domain;
	},
	/**
	 * @description Get the current region two letter code. Ex.: HU, RO
	 * @type {string}
	 */
	get region() {
		return useRuntimeConfig().public.activeConfig.region;
	},
	/**
	 * @description Get the current language two letter code. Ex.: hu, ro
	 * @type {string}
	 */
	get defaultLang() {
		return useRuntimeConfig().public.activeConfig.defaultLang;
	},
	regions,
	auth: false,
	AXIOS_DEFAULTS: {
		/**
		 * Base URL for API requests
		 * @type {string}
		 * @description The base URL for API requests. This is set to the API URL from the runtime config.
		 */
		get baseURL() {
			return useRuntimeConfig().public.activeConfig.apiUrl;
		},
		headers: {
			Accept: "application/json",
			"Content-Type": "application/json",
		},
	},
};

// AdaptiveContainer widths for JS
export const containerWidth = {
	0: 320,
	740: 680,
	1160: 1040,
	1520: 1400,
};
